import {
    SET_MY_ORDERS,
    GET_ROW_DATA,
    GET_ACTION_COLUMN,
    SET_MY_ORDERS_GRID_COUNT
} from './types'
const initialState = {
    myOrderData : [],
    approvalHistory : [],
    actionValue: false
    }
const reducers = (state=initialState,action:any) => {
    switch(action.type) {
        case SET_MY_ORDERS:
            return {
                ...state,
                myOrderData: action.value
            }
        case SET_MY_ORDERS_GRID_COUNT:
            return {
                ...state,
                myOrderGridCount: action.gridCount
            }
        case  GET_ROW_DATA:
            return {
                ...state,
                data: action.payload,
            }
        case  GET_ACTION_COLUMN:
            return {
                ...state,
                actionValue: action.payload,
            }
        default:
            return state
    }
}

export default reducers